<template>
  <v-row>
    <v-col md="2">
      <cboProvincias v-model="idProvincia"></cboProvincias>
    </v-col>
    <v-col md="3">
      <v-autocomplete
        v-if="idProvincia"
        outlined
        dense
        v-model="localidad"
        :items="Localidades"
        item-text="Descripcion"
        item-value="Localidad"
        label="Localidad"
        persistent-hint
        @change="traerPorLocalidad"
        hide-details
      ></v-autocomplete>
    </v-col>
    <v-col md="7">
      <v-autocomplete
        v-if="localidad"
        outlined
        dense
        v-model="efector"
        :items="ListaPorLocalidad"
        item-text="RAZON_SOCI"
        item-value="Id"
        label="Prestador"
        persistent-hint
        return-object
        @change="$emit('input', efector)"
        hide-details
        ><template v-slot:item="data">
          <v-list-item-content
            :style="
              data.item.incluyeplanAfiliado
                ? { color: 'green' }
                : { color: 'red' }
            "
          >
            <v-list-item-title>
              {{ data.item.nombreefector }} ({{ data.item.RAZON_SOCI }})
            </v-list-item-title>
            <v-list-item-subtitle
              >CUIT: {{ data.item.CUIT }}</v-list-item-subtitle
            >
          </v-list-item-content>
        </template>
      </v-autocomplete>
    </v-col>
  </v-row>
</template>

<script>
import cboProvincias from "@/components/Provincias/Combo";
import API from "@/lib/API.js";

export default {
  props: { 
    auditoria: {
      type: Boolean,
      default: false,
    },
    id_plan: { type: Number, default: 0 },
  },
  data() {
    return {
      idProvincia: 0,
      Lista: [],
      Localidades: [],
      localidad: "",
      ListaPorLocalidad: [],
      efector: [],
    };
  },
  computed: {},
  components: {
    cboProvincias,
  },
  methods: {
    traerPorLocalidad() {
      let lalista = this.Lista.filter((x) =>
        x.domiciliosprofesionales.some(
          (y) => y.descripcion_localidad == this.localidad
        )
      );
      this.ListaPorLocalidad = lalista.map((p) => ({
          ...p,
          incluyeplanAfiliado:
            p.Efector_Plan.findIndex((x) => x.Id_Plan === this.id_plan) > -1,
        }));
    },
  },
  watch: {
    async idProvincia() {
      this.localidad = "";
       let id_planBusco = this.id_plan;
      if (this.auditoria) {
        id_planBusco = 0;
      }
      this.Lista = await API.Efector.traerPorProvincia(
        this.idProvincia,
        id_planBusco
      );

      let cantidades = [];
      for (let efector of this.Lista) {
        for (let dom of efector.domiciliosprofesionales) {
          let loc = dom.descripcion_localidad;
          if (!cantidades.hasOwnProperty(loc)) {
            cantidades[loc] = 0;
          }
          cantidades[loc]++;
        }
      }
      this.Localidades = Object.keys(cantidades).map((k) => {
        return { Localidad: k, Descripcion: `${k} (${cantidades[k]})` };
      });

      //   this.Localidades = this.Lista.reduce((p, c) => {
      //     let loc = c.domiciliosprofesionales.descripcion_localidad;
      //     if (!p.hasOwnProperty(loc)) {
      //       p[loc] = 0;
      //     }
      //     p[loc]++;
      //     return p;
      //   }, {});
    },
  },
};
</script>

<style></style>
